import React from 'react';
import { getWidgetsForMode } from './widgetRegistry';
import './WidgetSelector.css';

/**
 * A collapsible panel listing all available widgets for the current mode.
 * Users can toggle each widget on or off.
 *
 * Props:
 *   mode           – 'single' | 'dual'
 *   visibleWidgets – Set of currently visible widget IDs
 *   onToggle       – (widgetId: string) => void
 *   onClose        – () => void
 */
function WidgetSelector({ mode, visibleWidgets, onToggle, onClose }) {
  const widgets = getWidgetsForMode(mode);

  return (
    <div className="widget-selector-panel">
      <div className="widget-selector-header">
        <span>Customize Widgets</span>
        <button className="widget-selector-close" onClick={onClose} aria-label="Close">✕</button>
      </div>

      <p className="widget-selector-hint">
        Toggle which widgets appear on the dashboard. Drag to reorder, resize handles on hover.
      </p>

      <ul className="widget-selector-list">
        {widgets.map(({ id, label }) => {
          const isVisible = visibleWidgets.has(id);
          return (
            <li key={id} className={`widget-selector-item ${isVisible ? 'visible' : ''}`}>
              <label className="widget-selector-label">
                <input
                  type="checkbox"
                  checked={isVisible}
                  onChange={() => onToggle(id)}
                  className="widget-selector-checkbox"
                />
                <span className="widget-selector-name">{label}</span>
              </label>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default WidgetSelector;
